
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { openDB } from 'idb';
//import axios from 'axios';
//import { useAuth } from "../AuthContext";
//import KakaoMap2 from "./KakaoMap2";
import "../styles/EnshrineView.css";

const DB_NAME = "MediaCache";
const STORE_NAME = "videos";


const ImageSlider = ({ images, interval = 10000 }) => {
    const [mediaSources, setMediaSources] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [volume, setVolume] = useState(1.0); // 기본 볼륨 100%
    const [isMuted, setIsMuted] = useState(false); // 음소거 상태 저장
    const videoRef = useRef(null);
    const hasRun = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const LoadingSpinner = () => (
        <div className="loading-overlay2">
            <div className="spinner2"></div>
        </div>
    );

    // IndexedDB 연결 및 Object Store 생성
    const openDatabase = async () => {
        return openDB(DB_NAME, 1, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME);
                    console.log("✅ Object Store 'videos'가 생성되었습니다.");
                }
            },
        });
    };
    

    // MP4 파일을 IndexedDB에서 가져오거나, 없으면 다운로드 후 저장
    const fetchAndStoreVideo = async (url) => {
        setIsLoading(true); // 로딩 시작
        //console.log("시작1");
        const db = await openDatabase();

        try {
            // IndexedDB에서 해당 URL의 Blob을 가져옴
            const cachedData = await db.get(STORE_NAME, url);

            if (cachedData) {
                //console.log(`🔹 IndexedDB에서 불러온 영상: ${url}`);
                //return URL.createObjectURL(cachedBlob);
                return { blobUrl: URL.createObjectURL(cachedData), originalUrl: url };
            }

            // 없으면 네트워크에서 다운로드 후 저장
            //console.log(`⬇️ 네트워크에서 다운로드: ${url}`);
            const response = await fetch(url);
            const blob = await response.blob();
            
            await db.put(STORE_NAME, blob, url);
            //console.log(`✅ IndexedDB에 저장 완료: ${url}`);
            
            //return URL.createObjectURL(blob);
            return { blobUrl: URL.createObjectURL(blob), originalUrl: url };
        } catch (error) {
            //console.error(`❌ fetchAndStoreVideo 오류:`, error);
            //return url; // 오류 발생 시 원본 URL 반환
            console.error(`❌ fetchAndStoreVideo 오류:`, error);

            // IndexedDB에서 오류 발생 시 원본 URL로부터 바로 동영상을 가져옴
            //console.log(`⬇️ 서버에서 직접 다운로드: ${url}`);
            const response = await fetch(url);
            const blob = await response.blob();

            return { blobUrl: URL.createObjectURL(blob), originalUrl: url };

        } finally {
            setIsLoading(false); // 로딩 완료
            //console.log("끝1");
        }
        
    };

    function isSmartTV() {
        const userAgent = navigator.userAgent.toLowerCase();
        return /smart-tv|smarttv|hbbtv|netcast|tizen|webos|opera tv|sonytv|lgbrowser|philips|panasonic|samsungbrowser|appletv|viera|hisense|firetv|android tv|googletv/i.test(userAgent);
    }

    // 📌 이미지/비디오를 미리 다운로드하여 메모리에 저장
    useEffect(() => {
        
        const loadMedia = async () => {   
            setIsLoading(true); // 로딩 시작
            //console.log("시작3");
            const blobs = await Promise.all(
                images.map(async (url) => {
                    
                    hasRun.current = true; // 첫 실행 후 플래그 설정
                    if (url.endsWith(".mp4")) {
                        //return fetchAndStoreVideo(url);
                        if (isSmartTV()) {
                            // 📌 스마트TV라면 원본 URL을 직접 사용
                            return { blobUrl: url, originalUrl: url };
                        } else {
                            // 📌 스마트TV가 아니라면 IndexedDB에 저장 후 사용
                            return fetchAndStoreVideo(url);
                        }
                    }
                    
                    const response = await fetch(url);
                    const blob = await response.blob();
                    //return URL.createObjectURL(blob);
                    
                    
                    return { blobUrl: URL.createObjectURL(blob), originalUrl: url };
                })
                
            );
            setIsLoading(false); // 로딩 시작
            //console.log("끝3");
            setMediaSources(blobs);
        };
        //console.log(images.length);
        
        if (!hasRun.current) { loadMedia(); }

        
        //if (images.length === 0) {                 }

    }, [images]);

    // 📌 모바일 환경 감지
    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        setIsMobile(/android|iphone|ipad|ipod/i.test(userAgent)); // 모바일 기기 감지
        setIsMuted(/android|iphone|ipad|ipod/i.test(userAgent));
    }, []);

    // 📌 로컬 스토리지에서 볼륨 & 음소거 상태 불러오기
    useEffect(() => {
        const savedVolume = localStorage.getItem("videoVolume");
        const savedMuted = localStorage.getItem("videoMuted");

        if (savedVolume !== null) {
            setVolume(parseFloat(savedVolume)); // 저장된 볼륨 적용
        }

        if (savedMuted !== null) {
            setIsMuted(savedMuted === "true"); // 음소거 상태 적용
        }
    }, []);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.volume = isMobile ? 0 : volume;
            videoRef.current.muted = isMobile || isMuted; // 🛠️ 음소거 적용
        }
    }, [volume, isMuted, isMobile]);


    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible" && videoRef.current) {
                videoRef.current.play().catch((error) => console.error("재생 오류:", error));
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


    useEffect(() => {
        if (isMobile) { setIsMuted(isMobile); }

        if (mediaSources.length === 0) return;

        let timeout;
        const currentItem = mediaSources[currentIndex];
        //console.log("currentItem:", currentItem);
        if (currentItem.originalUrl.endsWith(".mp4")) {
            // 🎬 비디오 자동 재생 및 끝난 후 다음 슬라이드로 이동
            if (videoRef.current) {
                videoRef.current.volume = isMobile ? 0 : volume; // 📌 PC에서는 저장된 볼륨 사용, 모바일은 음소거
                videoRef.current.muted = isMuted; // 📌 모바일은 무조건 음소거, PC는 저장된 상태 적용
                videoRef.current.play();
                videoRef.current.onended = () => {
                    timeout = setTimeout(() => {
                        setIsAnimating(true);
                        setCurrentIndex((prev) => (prev + 1) % mediaSources.length);
                    }, 0); // 비디오 끝난 후 1초(1000) 뒤 전환
                };
            }
        } else {
            // 🖼️ 이미지 5초 후 자동 전환
            timeout = setTimeout(() => {
                setIsAnimating(true); // 애니메이션 시작
                setTimeout(() => {
                    setCurrentIndex((prev) => (prev + 1) % mediaSources.length);
                    setIsAnimating(false); // 애니메이션 끝나면 false로 설정
                }, 1500); // 애니메이션 종료 후 1.5초 뒤에 이미지 전환
            }, interval);
        }

        return () => clearTimeout(timeout);
    }, [currentIndex, mediaSources, interval, volume, isMuted, isMobile]);

    useEffect(() => {
        if (isAnimating) {
            const timeout = setTimeout(() => {
                setIsAnimating(false);
            }, 1100); // 애니메이션이 끝나면 isAnimating을 false로 설정
            return () => clearTimeout(timeout);
        }
    }, [isAnimating]);

    // 📌 볼륨 변경 핸들러 (비디오 컨트롤에서 조절한 값 저장)
    const handleVolumeChange = (event) => {
        const newVolume = event.target.volume;
        const newMuted = videoRef.current.muted;
        setVolume(newVolume);
        setIsMuted(newMuted);

        //setIsMuted(newVolume === 0); // 🛠️ 볼륨 0이면 음소거
        localStorage.setItem("videoVolume", newVolume.toString());
        localStorage.setItem("videoMuted", newMuted.toString()); // 📌 음소거 상태 저장
        //console.log("비디오 설정:", { volume, isMuted, muted: videoRef.current.muted });
    };

    return (
        <div className="slider-container">
            {mediaSources.length > 0 && mediaSources[currentIndex]?.originalUrl?.endsWith(".mp4") ? (
                <div
                    className="video-wrapper"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <video
                        ref={videoRef}
                        src={mediaSources[currentIndex]?.blobUrl}
                        //src={mediaSources[currentIndex]?.originalUrl}
                        //src={mediaSources[currentIndex]?.blobUrl || mediaSources[currentIndex]?.originalUrl} // blobUrl이 없으면 originalUrl을 사용
                        className={`slide-media ${isAnimating ? "fade-in zoom-in blur-out" : ""}`}
                        controls={isHovered}
                        //muted={isMobile || isMuted} // 📌 모바일은 무조건 음소거, PC는 저장된 상태 적용
                        muted={isMuted} // 📌 모바일은 무조건 음소거, PC는 저장된 상태 적용
                        autoPlay
                        playsInline
                        preload="auto" // 🎯 추가된 부분
                        onVolumeChange={handleVolumeChange} // 🎯 볼륨 변경 감지
                        //onLoadedData={() => console.log("Video loaded in memory!")}
                        //onLoadedData={() => setIsLoaded(true)} // 한 번 로드되면 상태 변경
                        /*
                        onCanPlay={() => {
                            if (videoRef.current) {
                                videoRef.current.volume = isMobile ? 0 : volume; // 📌 PC는 저장된 볼륨 적용
                                videoRef.current.muted = isMobile || isMuted; // 📌 PC는 저장된 음소거 상태 유지
                                
                                videoRef.current.play().catch((error) => console.error("자동 재생 오류:", error));
                            }
                        }}
                        onVolumeChange={handleVolumeChange} // 📌 볼륨 변경 감지하여 저장
                        onMuteChange={handleMuteChange} // 📌 음소거 변경 감지하여 저장     
                        */
                    />
                </div>
            ) : (
                    <img
                        src={mediaSources[currentIndex]?.blobUrl}
                    alt={`slide-${currentIndex}`}
                    className={`slide-media ${isAnimating ? "fade-in zoom-in blur-out" : ""}`}
                />
            )}

            <button
                className="prev-btn"
                onClick={() => {
                    setIsAnimating(true);
                    setTimeout(() => {
                        setCurrentIndex((prevIndex) => (prevIndex - 1 + mediaSources.length) % mediaSources.length);
                        setIsAnimating(false);
                    }, 500);
                }}
            >
                ◀
            </button>

            <button
                className="next-btn"
                onClick={() => {
                    setIsAnimating(true);
                    setTimeout(() => {
                        setCurrentIndex((prevIndex) => (prevIndex + 1) % mediaSources.length);
                        setIsAnimating(false);
                    }, 500);
                }}
            >
                ▶
            </button>

            {isLoading && <LoadingSpinner />}

        </div>
    );
};












const EnshrineView = () => {    
    //const { user, setUser } = useAuth();

    const [pageChange, setPageChange] = useState(0); // 상태로 선언해야 변화에 따라 렌더링됨
    

    const location = useLocation();    
    const [enshrineView /*, setEnshrineView */] = useState(location.state?.enshrine || null);    
    const navigate = useNavigate();
    
    const [ppictureUrl, setPpictureUrl] = useState("");
    const [cpictureUrl, setCpictureUrl] = useState("");
    const [epictureUrl, setEpictureUrl] = useState("");
    
    const [mpicture01Url, setMpicture01Url] = useState("");
    const [mpicture02Url, setMpicture02Url] = useState("");
    const [mpicture03Url, setMpicture03Url] = useState("");
    const [mpicture04Url, setMpicture04Url] = useState("");
    const [mpicture05Url, setMpicture05Url] = useState("");
    const [mpicture06Url, setMpicture06Url] = useState("");
    const [mpicture07Url, setMpicture07Url] = useState("");
    const [mpicture08Url, setMpicture08Url] = useState("");
    const [mpicture09Url, setMpicture09Url] = useState("");
    const [mpicture10Url, setMpicture10Url] = useState("");
    const [mvideoUrl, setMvideoUrl] = useState("");
        
    const imgRef = useRef(null);

    const hasFetched = useRef(false);  // ✅ 첫 실행 여부 체크
    const hasFetched2 = useRef(false);  // ✅ 첫 실행 여부 체크

    const [isLoading, setIsLoading] = useState(false);

    const LoadingSpinner = () => (
        <div className="loading-overlay">
            <div className="spinner"></div>
        </div>
    );

    //const [markers, setMarkers] = useState([]);
    const [address, setAddress] = useState("위치정보를 찾고있습니다...");
    const { cemeteryLatitude, cemeteryLongitude } = enshrineView;
    const { enshrineLatitude, enshrineLongitude } = enshrineView;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        if (hasFetched2.current) return;  // ✅ 두 번째 실행 방지
        hasFetched2.current = true;       // ✅ 첫 실행 후 true로 설정

        let latiData = cemeteryLatitude || enshrineLatitude;
        let longiData = cemeteryLongitude || enshrineLongitude;

        if (!latiData || !longiData) {
            //console.log("위도, 경도 정보 없음. 실행 중단");
            return; // 좌표 없으면 실행하지 않음
        }

        // 기존 스크립트 확인
        const existingScript = document.getElementById("kakao-map-script2");
        //console.log("기존 스크립트 존재 여부:", existingScript);

        if (!existingScript) {
            //console.log("카카오맵 스크립트 추가 시작");
            const script = document.createElement("script");
            script.id = "kakao-map-script2"; // ✅ 중복 로드 방지
            script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=d7ae19a6101738fc44ac012874d79a76&libraries=services`;
            script.async = true;
            script.onload = () => {
                //console.log("카카오맵 SDK 로드 완료");
                if (window.kakao) {
                    //console.log("window.kakao 객체 존재 확인됨");
                    window.kakao.maps.load(() => {
                        //console.log("카카오맵 라이브러리 로드 완료");
                        initMap();
                    });
                } else {
                    console.error("window.kakao 객체가 없습니다.");
                }
            };
            document.body.appendChild(script);
        } else {
            //console.log("기존 카카오맵 스크립트 사용");
            if (window.kakao) {
                window.kakao.maps.load(() => {
                    //console.log("카카오맵 라이브러리 로드 완료");
                    initMap();
                });
            } else {
                //console.error("window.kakao 객체가 없습니다.");
            }
        }

        // ✅ initMap 함수 정의
        function initMap() {
            //console.log("initMap 실행됨");
            const container = document.getElementById("map5");
            if (!container) {
                //console.error("map5 컨테이너가 없습니다.");
                return; // 컨테이너가 없으면 실행하지 않음
            }
            
            const options = {
                center: new window.kakao.maps.LatLng(latiData, longiData),
                level: 3,
                mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
            };

            let map;
            try {
                map = new window.kakao.maps.Map(container, options);

                // 주소 변환
                const geocoder = new window.kakao.maps.services.Geocoder();
                geocoder.coord2Address(longiData, latiData, (result, status) => {
                    if (status === window.kakao.maps.services.Status.OK) {
                        const roadAddress = result[0]?.road_address?.address_name || "";
                        const jibunAddress = result[0]?.address?.address_name || "";
                        setAddress(roadAddress || jibunAddress || "주소를 찾을 수 없습니다.");
                    }
                });

                //console.log("카카오맵 생성 완료");
            } catch (error) {
                //console.error("지도 생성 오류:", error);
                return;
            }

            // 마커 추가
            const markerData = [
                { id: 1, lat: latiData, lng: longiData, name: "포인트 1", description: "설명 1" },
            ];
            //setMarkers(markerData);

            markerData.forEach((data) => {
                const position = new window.kakao.maps.LatLng(data.lat, data.lng);
                const marker = new window.kakao.maps.Marker({ position });
                marker.setMap(map);
            });

            
        }
    }, [cemeteryLatitude, cemeteryLongitude, enshrineLatitude, enshrineLongitude]);

    // ✅ 2) pageChange가 0으로 바뀌면 지도 다시 초기화
    useEffect(() => {
        if (pageChange !== 0) return;

        let latiData = cemeteryLatitude || enshrineLatitude;
        let longiData = cemeteryLongitude || enshrineLongitude;

        if (!latiData || !longiData) return;

        // window.kakao가 이미 로드되어 있을 경우만
        if (window.kakao && window.kakao.maps) {
            window.kakao.maps.load(() => {
                initMap(latiData, longiData);
            });
        }
    }, [pageChange]);

    // ✅ initMap 함수: 컴포넌트 외부 or 내부에서 정의
    function initMap(lat, lng) {
        const container = document.getElementById("map5");
        if (!container) return;

        const options = {
            center: new window.kakao.maps.LatLng(lat, lng),
            level: 3,
            mapTypeId: window.kakao.maps.MapTypeId.HYBRID,
        };

        const map = new window.kakao.maps.Map(container, options);

        const geocoder = new window.kakao.maps.services.Geocoder();
        geocoder.coord2Address(lng, lat, (result, status) => {
            if (status === window.kakao.maps.services.Status.OK) {
                const roadAddress = result[0]?.road_address?.address_name || "";
                const jibunAddress = result[0]?.address?.address_name || "";
                setAddress(roadAddress || jibunAddress || "주소를 찾을 수 없습니다.");
            }
        });

        const marker = new window.kakao.maps.Marker({
            position: new window.kakao.maps.LatLng(lat, lng),
        });
        marker.setMap(map);
    }

   
    useEffect(() => {

        if (hasFetched.current) return;  // ✅ 두 번째 실행 방지
        hasFetched.current = true;       // ✅ 첫 실행 후 true로 설정        

        // ✅ `enshrineView`가 없으면 홈으로 이동
        if (!enshrineView) {
            console.warn("잘못된 접근입니다.");
            navigate("/enshrine", { replace: true });
            //navigate(-1)
            return;
        }


        // URL을 동적으로 생성하는 함수
        const generateImageUrl = ( category, fileName) => {
            return fileName ? `https://bitdamstorage.blob.core.windows.net/bitdamstorage/${enshrineView.enshrineCode}/${category}/${fileName}` : "";
        };        
        
        const ppictureUrl = generateImageUrl("C", enshrineView.ppictureURL);
        const cpictureUrl = generateImageUrl("A", enshrineView.cpictureURL);
        const epictureUrl = generateImageUrl( "B", enshrineView.epictureURL);
        
        const mpicture01Url = generateImageUrl( "D", enshrineView.mpicture01URL);
        const mpicture02Url = generateImageUrl( "E", enshrineView.mpicture02URL);
        const mpicture03Url = generateImageUrl( "F", enshrineView.mpicture03URL);
        const mpicture04Url = generateImageUrl( "G", enshrineView.mpicture04URL);
        const mpicture05Url = generateImageUrl( "H", enshrineView.mpicture05URL);
        const mpicture06Url = generateImageUrl( "I", enshrineView.mpicture06URL);
        const mpicture07Url = generateImageUrl( "J", enshrineView.mpicture07URL);
        const mpicture08Url = generateImageUrl( "K", enshrineView.mpicture08URL);
        const mpicture09Url = generateImageUrl( "L", enshrineView.mpicture09URL);
        const mpicture10Url = generateImageUrl( "M", enshrineView.mpicture10URL);
        const mvideoUrl = generateImageUrl( "N", enshrineView.mvideoURL);
        
        // 이미지 URL과 상태 setter를 객체 배열로 관리
        const imageUrls = [
            { url: ppictureUrl, setter: setPpictureUrl }, // 영정사진
            { url: cpictureUrl, setter: setCpictureUrl }, // 묘지사진
            { url: epictureUrl, setter: setEpictureUrl }, // 봉안사진
           
            { url: mpicture01Url, setter: setMpicture01Url }, // 추억사진
            { url: mpicture02Url, setter: setMpicture02Url },
            { url: mpicture03Url, setter: setMpicture03Url },
            { url: mpicture04Url, setter: setMpicture04Url },
            { url: mpicture05Url, setter: setMpicture05Url },
            { url: mpicture06Url, setter: setMpicture06Url },
            { url: mpicture07Url, setter: setMpicture07Url },
            { url: mpicture08Url, setter: setMpicture08Url },
            { url: mpicture09Url, setter: setMpicture09Url },
            { url: mpicture10Url, setter: setMpicture10Url },            
            { url: mvideoUrl, setter: setMvideoUrl },
        ];

        //console.log(imageUrls);
        
        const fetchImage = async () => {

            setIsLoading(true); // 로딩 시작

            try {
                /*
                const imageUrl = `https://bitdamstorage.blob.core.windows.net/bitdamstorage/${enshrineView.enshrineCode}/C/${enshrineView.ppictureURL}`;
                console.log(imageUrl);

                const response = await axios.get(imageUrl, { withCredentials: false });
                setImageUrl(imageUrl);
                */

                /*
                const requests = imageUrls
                    .filter(({ url }) => url !== "") // 빈 문자열이 아닌 URL만 처리
                    .map(({ url }) => axios.get(url, { withCredentials: false }));

                const responses = await Promise.all(requests); // 병렬 요청

                // 상태 업데이트
                responses.forEach((response, index) => {
                    const { setter } = imageUrls[index];
                    setter(imageUrls[index].url);
                });
                */
                
                // 이미지 URL을 상태로 저장
                setPpictureUrl(ppictureUrl); // 영정사진
                setCpictureUrl(cpictureUrl); // 묘지사진
                setEpictureUrl(epictureUrl); // 봉안사진
                
                setMpicture01Url(mpicture01Url); // 추억사진
                setMpicture02Url(mpicture02Url); // 추억사진
                setMpicture03Url(mpicture03Url); // 추억사진
                setMpicture04Url(mpicture04Url); // 추억사진
                setMpicture05Url(mpicture05Url); // 추억사진
                setMpicture06Url(mpicture06Url); // 추억사진
                setMpicture07Url(mpicture07Url); // 추억사진
                setMpicture08Url(mpicture08Url); // 추억사진
                setMpicture09Url(mpicture09Url); // 추억사진
                setMpicture10Url(mpicture10Url); // 추억사진
                setMvideoUrl(mvideoUrl); // 추억사진
                
                

            } catch (error) {
                
                console.error("이미지를 불러오는 중 오류 발생:", error);
            } finally {
                setIsLoading(false); // 로딩 완료
            }
        };

        fetchImage();
        
    }, [enshrineView, navigate]); // ✅ `enshrineView`가 준비된 후 실행
    

    

    const calculateAge = (birthDate, deathDate) => {
    const birth = new Date(birthDate);
    const death = new Date(deathDate);
    let age = death.getFullYear() - birth.getFullYear();
    const monthDiff = death.getMonth() - birth.getMonth();
        const dayDiff = death.getDate() - birth.getDate();  
        

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--; // 생일이 지나지 않았으면 나이에서 1 빼기
    }
    return age;
};
    // ✅ jesatype 상태 관리 (초기값: DB 값 또는 1)
    const [jesaType, setJesaType] = useState("1");

    useEffect(() => {
        const valid = ["1", "2", "3", "4"].includes(enshrineView.jesaType);
        setJesaType(valid ? enshrineView.jesaType : "1");
    }, [enshrineView.jesaType]);

    // ✅ 이미지 경로 동적으로 결정
    const imageUrl = `https://bitdamstorage.blob.core.windows.net/bitdamstorage/v${jesaType}.jpg`;

    // ✅ 버튼 클릭 시 jesatype 업데이트
    const handleButtonClick = (typeNum) => {
        const newType = String(typeNum);
        setJesaType(newType);
    };

    return (
        
      <div>
      {pageChange === 0 ? (
                <div className="enshrineview-page">

                    <div className="enshrineview-wrapper">
                        {/* 왼쪽 프레임 */}
                        <div className="left-frame">
                            <div className="img-container">
                                <img
                                    src={ppictureUrl ? ppictureUrl : "https://bitdamstorage.blob.core.windows.net/bitdamstorage/flower.jpg"}
                                    alt="영정사진"
                                    ref={imgRef}
                                    onClick={() => setPageChange(1)} // 클릭 시 상태 변경
                                    style={{ cursor: 'pointer' }} // 클릭 가능한 느낌을 주기 위한 스타일 (선택사항)
                                />
                                {/* <img src={ppictureUrl || null} alt="영정사진" ref={imgRef} /> */}
                            </div>
                            {enshrineView.deceasedName ? (
                                <>
                                    <div className="text-container">
                                        <p className="deceased-info">
                                            <span className="m1-text">故</span>
                                            <span className="m2-text"> {enshrineView.deceasedName} </span>
                                            <span className="m3-text">
                                                {enshrineView.deceasedBDate} ~ {enshrineView.deceasedDDate}
                                                {enshrineView.deceasedBDate && enshrineView.deceasedDDate
                                                    ? ` 만 ${calculateAge(enshrineView.deceasedBDate, enshrineView.deceasedDDate)}세`
                                                    : ""}
                                            </span>
                                        </p>

                                        <p className="normal-text">{enshrineView.bereavedInfo}</p>
                                        <p className="normal-text">{enshrineView.deceasedMemo}</p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    {enshrineView.enshrineType === "A" && <span className="m2-text"> 무연고묘 봉안<br />{enshrineView.enshrineCode}   </span>}
                                    {enshrineView.enshrineType === "B" && <span className="m2-text"> 무연고묘 확인(미봉안)<br />{enshrineView.enshrineCode} </span>}
                                </>


                            )}


                        </div>

                        {/* 오른쪽 컨테이너 */}
                        <div className="right-container">
                            {/* 오른쪽 상단 프레임 */}
                            <div className="right-frame">
                                <ImageSlider
                                    images={[

                                        cpictureUrl,
                                        epictureUrl,

                                        mpicture01Url,
                                        mpicture02Url,
                                        mpicture03Url,
                                        mpicture04Url,
                                        mpicture05Url,
                                        mpicture06Url,
                                        mpicture07Url,
                                        mpicture08Url,
                                        mpicture09Url,
                                        mpicture10Url,
                                        mvideoUrl,
                                    ].filter(url => url?.trim() !== "" && url !== null && url !== undefined)}
                                />
                            </div>

                            {/* 오른쪽 하단 프레임 */}
                            <div className="bottom-frame">
                                {/* <img src={cpictureUrl} alt="묘지사진" /> */}


                                <div className="map5-container">
                                    <div id="map5"></div>
                                    {/* 📌 주소 표시 박스 (지도의 오른쪽 상단) */}
                                    <div style={{
                                        position: "absolute",
                                        top: "10px",
                                        right: "10px",
                                        backgroundColor: "rgba(0, 0, 0, 0.6)", // 반투명 검은 배경
                                        color: "#fff",
                                        padding: "8px 12px",
                                        borderRadius: "5px",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap", // 주소가 길어질 경우 줄바꿈 방지
                                        zIndex: 1000 // 지도보다 위에 표시
                                    }}>
                                        {address}
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>


                    



                </div>
            ) : (
                    <div className="enshrineview-page1">
                        {/* ✅ 배경 이미지 */}
                        <img
                            src={imageUrl}
                            alt="배경화면"
                            
                            className="responsive-image"
                        />




                        <div className="centered-images">
                            <div className="frame-with-text">
                                {/* 액자 + 영정 */}
                                <div className="frame-wrapper">
                                    <img
                                        src={
                                            ppictureUrl
                                                ? ppictureUrl
                                                : 'https://bitdamstorage.blob.core.windows.net/bitdamstorage/flower.jpg'
                                        }
                                        alt="영정사진"
                                        className="portrait-image"
                                        onClick={() => setPageChange(0)}
                                    />

                                    {/* 액자 이미지 */}
                                    <img
                                        src="https://bitdamstorage.blob.core.windows.net/bitdamstorage/frame.png"
                                        alt="액자"
                                        className="frame-image"
                                    />
                                </div>

                                {/* 글자 */}
                                <div className="bottom-text">
                                    <div className="line1">
                                        <span className="m11-text">故</span>
                                        <span className="m22-text">{enshrineView.deceasedName}</span>
                                    </div>
                                    <div className="line2 m33-text">
                                        {enshrineView.deceasedBDate} ~ {enshrineView.deceasedDDate}
                                        {enshrineView.deceasedBDate && enshrineView.deceasedDDate
                                            ? ` 만 ${calculateAge(enshrineView.deceasedBDate, enshrineView.deceasedDDate)}세`
                                            : ''}
                                    </div>
                                </div>
                            </div>
                        </div>

                       
                        
                       

                        {/* ✅ 유형 선택 버튼 */}
                        <div className="top-right-buttons">
                            {["유교", "불교", "기독교", "천주교"].map((label, index) => {
                                const num = String(index + 1);
                                return (
                                    <button
                                        key={num}
                                        onClick={() => handleButtonClick(num)}
                                        className={jesaType === num ? "selected" : ""}
                                    >
                                        {label}
                                    </button>
                                );
                            })}


                            {/* ✅ 나가기 버튼 */}
                            <button className="exit-button5" onClick={() => setPageChange(0)}>
                                나가기
                            </button>
                        </div>



                    </div>

       
            
      )}

            {isLoading && <LoadingSpinner />}

    </div>
        


        
    );



    
};

export default EnshrineView;
